export const decodeBase64Bytes = (contentBase64: string) => {
  const binary = atob(contentBase64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i)
  }
  return bytes
}

/** Decode a GraphQL PDF payload and trigger a browser download. */
export const downloadBase64Pdf = (
  fileName: string,
  contentBase64: string,
  mimeType = 'application/pdf',
) => {
  const bytes = decodeBase64Bytes(contentBase64)
  const blob = new Blob([bytes], { type: mimeType || 'application/pdf' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName || 'agreement.pdf'
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
